<div class="labels-container">
  <ul class="tabs-block">
    @for (tab of tabs; track trackByTitle($index, tab)) {
      <li class="tabs-item" [class.active]="tab.active" (click)="selectTab(tab)">
        <span class="tabs-item-title">
          {{ tab.title() }}
        </span>
      </li>
    }
  </ul>
</div>
<ng-content />
